export default function DevicesNavService(gettext) {
  'ngInject';

  const module = {
    id: 'devices',
    name: 'Devices',
    navTitle: gettext('Device Management'),
    sref: 'devices2',
    icon: 'ti-rss-alt',
    priority: 80,

    items: [
      {
        name: gettext('Devices'),
        mobileName: gettext('View Devices'),
        sref: 'devices2.base',
        group: 'devices'
      },
      {
        name: gettext('Single Activation'),
        sref: 'devices2.activations.single',
        group: 'activations'
      },
      {
        name: gettext('Bulk Activation'),
        sref: 'devices2.activations.bulk',
        group: 'activations'
      },
      {
        name: gettext('Bulk Activation'),
        sref: 'devices2.activations.custom',
        group: 'activations'
      }
    ],
    groups: [
      {
        id: 'devices',
        name: gettext('Devices')
      },
      {
        id: 'activations',
        name: gettext('Activations')
      }
    ]
  };

  this.getModule = function () {
    return module;
  };
}
